import script from "./InputSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSearch.vue?vue&type=script&setup=true&lang=js"

import "./InputSearch.vue?vue&type=style&index=0&id=3e6cd736&lang=scss"

const __exports__ = script;

export default __exports__